module.exports = __webpack_public_path__ + "media/home/mdz-95baba49.png";